import { Box, Heading, Stack, Text } from "@chakra-ui/layout";
import React from "react";

function SettingsFragment({ slug, title }) {
  return (
    <Stack>
      <Heading>
        <Text>Settings</Text>
        <Box mt={2} h={"2px"} w={"60%"} maxW="100px" bg={"accent.1"} />
      </Heading>
    </Stack>
  );
}

export default SettingsFragment;
